import DocumentsCard from "../Reusable/DocumentsCard";

const DocumentCardsSection = ({
  documentCards,
  handleDocumentNavigation,
}) => {
  return (
     <div className="flex flex-col bg-white p-3 rounded-lg gap-3">
      {documentCards.map(
        ({ cardData, stats, route, stateKey, className }) => (
          <div className={className} key={stateKey}>
            <DocumentsCard
              item={{
                ...cardData,

                expiredCount: stats.expired.length,

                oneToSevenCount: stats.oneToSevenDays.length,

                eightToThirtyCount:
                  stats.eightToThirtyDays.length,

                thirtyOneToSixtyCount:
                  stats.thirtyOneToSixtyDays.length,

                handleExpired: () =>
                  handleDocumentNavigation(
                    "expired",
                    stats,
                    route,
                    stateKey
                  ),

                handleOneToSeven: () =>
                  handleDocumentNavigation(
                    "1-7",
                    stats,
                    route,
                    stateKey
                  ),

                handleEightToThirty: () =>
                  handleDocumentNavigation(
                    "8-30",
                    stats,
                    route,
                    stateKey
                  ),

                handleThirtyOneToSixty: () =>
                  handleDocumentNavigation(
                    "31-60",
                    stats,
                    route,
                    stateKey
                  ),
              }}
            />
          </div>
        )
      )}
    </div>
  );
};

export default DocumentCardsSection;